import { render, staticRenderFns } from "./p30.vue?vue&type=template&id=035c5d90&scoped=true&"
import script from "./p30.vue?vue&type=script&lang=js&"
export * from "./p30.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035c5d90",
  null
  
)

export default component.exports